export const ROLES = {
    INVESTOR: 'INVESTOR',
    ADMIN: 'ADMIN',
    SUPER_ADMIN: 'SUPER_ADMIN'
};